import { createAction } from 'typesafe-actions'
import VehicleCode from '../../../entities/VehicleCode'

export const startSaveConfiguration = createAction('CMD / SaveConfiguration / start')()

export const saveConfigurationGotVehicleCode = createAction('EVT / SaveConfiguration / got vehicle code')<{ vehicleCode: VehicleCode }>()

export const saveConfigurationRedirect = createAction('CMD / SaveConfiguration / redirect')()
